import React from "react";

import { Icon, IconProps } from "../";

export const LocalParkingIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M107,619 C108.1,619 109,619.9 109,621 L109,621 L109,635 C109,636.1 108.1,637 107,637 L107,637 L93,637 C91.9,637 91,636.1 91,635 L91,635 L91,621 C91,619.9 91.9,619 93,619 L93,619 Z M101,622 L97.3333333,622 C96.6,622 96,622.6 96,623.333333 L96,632.666667 C96,633.4 96.5166667,634 97.25,634 C97.9833333,634 98.5,633.4 98.5,632.666667 L98.5,630 L101,630 C103,630 104.518492,628.225783 104.5,626 C104.481508,623.774217 103,622 101,622 Z M100.5,624.5 C101.328427,624.5 102,625.171573 102,626 C102,626.828427 101.328427,627.5 100.5,627.5 L98.5,627.5 L98.5,624.5 L100.5,624.5 Z"
        transform="translate(-88 -616)"
      />
    </Icon>
  );
};
